var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.036,
    height: 21.235,
    viewBox: "0 0 23.036 21.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1648",
    "data-name": "Rectangle 1648",
    width: 23.036,
    height: 21.235,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4249",
    "data-name": "Group 4249",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4248",
    "data-name": "Group 4248",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M7.914,21.235a.7.7,0,0,1-.7-.7.7.7,0,0,1,.7-.7h7.212a.7.7,0,0,1,.7.661v.038a.7.7,0,0,1-.7.7ZM2.5,17.626a2.5,2.5,0,0,1-2.5-2.5V2.5A2.5,2.5,0,0,1,2.5,0H20.537a2.5,2.5,0,0,1,2.5,2.5V15.127a2.5,2.5,0,0,1-2.5,2.5ZM2.5,1.4A1.1,1.1,0,0,0,1.4,2.5V15.127a1.1,1.1,0,0,0,1.1,1.1H20.537a1.1,1.1,0,0,0,1.1-1.1V2.5a1.1,1.1,0,0,0-1.1-1.1ZM11.521,13.12a.7.7,0,0,1-.7-.7V6.9L9.314,8.41a.7.7,0,0,1-.991-.992l2.7-2.7a.7.7,0,0,1,.988,0l2.709,2.7a.7.7,0,0,1-.991.992L12.22,6.9v5.524a.7.7,0,0,1-.7.7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.253db4d2a18921ff4ce9e86e3848fa73.svg";
export { ForwardRef as ReactComponent };